import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
	NotificationContainer,
	NotificationManager,
} from "react-notifications";

import DashboardIcon from "@material-ui/icons/Dashboard";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

import AmuraLogoImg from "../assets/images/amura-logo.svg";
// Inactive icons
import DashboardImg from "../assets/images/ico-dashboard.svg";
import LiveMeterFeedImg from "../assets/images/ico-live-meter-feed.svg";
import ReportImg from "../assets/images/ico-reports.svg";
// import InventoryImg from "../assets/images/ico-in";
import ControlsImg from "../assets/images/ico-control.svg";
import AlertsImg from "../assets/images/ico-alert.svg";
import MapViewImg from "../assets/images/ico-target.svg";
import InventoryImg from "../assets/images/ico-inventory.svg";
import SettingsImg from "../assets/images/ico-settings.svg";
import UsersImg from "../assets/images/ico-person.svg";
import VendorDetailsImg from "../assets/images/ico-target.svg";
import LogoutImg from "../assets/images/ico-logout-white.svg";
// active icons
import ListIcon from '@mui/icons-material/List';
import DashboardActiveImg from "../assets/images/ico-dashboard-active.svg";
import LiveMeterFeedActiveImg from "../assets/images/ico-live-meter-feed-active.svg";
import ReportActiveImg from "../assets/images/ico-reports-active.svg";
import ControlsActiveImg from "../assets/images/ico-control-active.svg";
import AlertsActiveImg from "../assets/images/ico-alert-active.svg";
import MapViewActiveImg from "../assets/images/ico-target-active.svg";
import InventoryActiveImg from "../assets/images/ico-inventory-active.svg";
import SettingsActiveImg from "../assets/images/ico-settings-active.svg";
import UsersActiveImg from "../assets/images/ico-person-active.svg";
import VendorDetailsActiveImg from "../assets/images/ico-target-active.svg";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import LabelImportantIcon from '@material-ui/icons/LabelImportant';
import FlagIcon from '@material-ui/icons/Flag';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import PersonIcon from '@mui/icons-material/Person';
import LockOpenIcon from '@mui/icons-material/LockOpen';

import "../styles/sidebar.scss";
import { checkUserAccess, logout, masterLogout } from "../apis/auth";
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import OfflinePinIcon from '@mui/icons-material/OfflinePin';
import AssessmentIcon from '@mui/icons-material/Assessment';
import Diversity3Icon from '@mui/icons-material/Diversity3';
const sideMenuList = [
	{
		name: "dashboard",
		label: "Dashboard",
		path: "/dashboard",
		icon: <img src={DashboardActiveImg} />,
		getIcon: (isSelected) => (isSelected ? <img src={DashboardActiveImg} /> : <img src={DashboardImg} />),
		isActive: true,
	},
	{
		name: "liveMeterFeed",
		label: "Live Meter Feed",
		path: "/live-meter-feed",
		icon: <img src={LiveMeterFeedImg} />,
		getIcon: (isSelected) =>
			isSelected ? <img src={LiveMeterFeedActiveImg} /> : <img src={LiveMeterFeedImg} />,
		isActive: false,
	},
	{
		name: "reports",
		label: "Reports",
		icon: <img src={ReportImg} />,
		getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
		isActive: false,
 		subMenu: [
			{
				name: "energy-saving-report",
				label: "Energy Saving Report",
				path: "/reports",
				icon: <img src={ReportImg} />,
				getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
				isActive: false,
			},
			// {
			// 	name: "slc-error-report",
			// 	label: "SLC Error Report",
			// 	path: "/slc-error-report",
			// 	icon: <img src={ReportImg} />,
			// 	getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
			// 	isActive: false,
			// },
			{
				name: "lamp-error-report",
				label: "Lamp Failure Report",
				path: "/lamp-error-report",
				icon: <img src={ReportImg} />,
				getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
				isActive: false,
			},

		]
	},
	// {
	// 	name: "inventory",
	// 	label: "Inventory",
	// 	icon: <img src={ReportImg} />,
	// 	getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
	// 	isActive: false,
	// 	subMenu: [
	// 		{
	// 			name: "slc-inventory",
	// 			label: "SLC",
	// 			path: "/slc-inventory",
	// 			icon: <img src={ReportImg} />,
	// 			getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
	// 			isActive: false,
	// 		},
	// 		{
	// 			name: "lamp-inventory",
	// 			label: "Lamp",
	// 			path: "/lamp-inventory",
	// 			icon: <img src={ReportImg} />,
	// 			getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
	// 			isActive: false,
	// 		},
	// 		{
	// 			name: "ilm-inventory",
	// 			label: "ILM",
	// 			path: "/ilm-inventory",
	// 			icon: <img src={ReportImg} />,
	// 			getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
	// 			isActive: false,
	// 		},

	// 	]
	// },
	{
		name: "ticket",
		label: "Ticket",
		icon: <ConfirmationNumberIcon />,
		getIcon: (isSelected) => (isSelected ? <ConfirmationNumberIcon /> : <ConfirmationNumberIcon />),
		isActive: false,
		subMenu: [
			{
				name: "create-tickets",
				label: "Create Tickets",
				path: "/create-tickets",
				icon: <FlagIcon />,
				getIcon: (isSelected) => (isSelected ? <FlagIcon /> : <FlagIcon />),
				isActive: false,
			},
			{
				name: "active-tickets",
				label: "Active Tickets",
				path: "/active-tickets",
				icon: <LabelImportantIcon />,
				getIcon: (isSelected) => (isSelected ? <LabelImportantIcon /> : <LabelImportantIcon />),
				isActive: false,
			},
			{
				name: "closed-tickets",
				label: "Closed Tickets",
				path: "/closed-tickets",
				icon: <PlaylistAddCheckIcon />,
				getIcon: (isSelected) => (isSelected ? <PlaylistAddCheckIcon /> : <PlaylistAddCheckIcon />),
				isActive: false,
			},
		]
	},
	{
		name: "events",
		label: "Event Report",
		path: "/event-report",
		icon: <img src={ReportImg} />,
		getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
		isActive: false,
	},
	// {
	//   name: "control",
	//   label: "Control",
	//   path: "/control",
	//   icon: <img src={ControlsImg} />,
	//   getIcon: (isSelected) => (isSelected ? ControlsActiveImg : ControlsImg),
	//   isActive: false,
	// },
	// {
	//   name: "alerts",
	//   label: "Alerts",
	//   path: "/alerts",
	//   icon: <img src={AlertsImg} />,
	//   getIcon: (isSelected) => (isSelected ? AlertsActiveImg : AlertsImg),
	//   isActive: false,
	// },
	// {
	//   name: "mapView",
	//   label: "Map View",
	//   path: "/map-view",
	//   icon: <img src={MapViewImg} />,
	//   getIcon: (isSelected) => (isSelected ? MapViewActiveImg : MapViewImg),
	//   isActive: false,
	// },
	// {
	//   name: "inventory",
	//   label: "Inventory",
	//   path: "/inventory",
	//   icon: <img src={InventoryImg} />,
	//   getIcon: (isSelected) => (isSelected ? InventoryActiveImg : InventoryImg),
	//   isActive: false,
	// },
	{
		name: "inventory",
		label: "Inventory",
		icon: <img src={InventoryImg} />,
		getIcon: (isSelected) => (isSelected ? <img src={InventoryActiveImg} /> : <img src={InventoryImg} />),
		isActive: false,
		subMenu: [
			{
				name: "slc-inventory",
				label: "SLC",
				path: "/slc-inventory",
				icon: <img src={ReportImg} />,
				getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
				isActive: false,
			},
			{
				name: "lamp-inventory",
				label: "Lamp",
				path: "/lamp-inventory",
				icon: <img src={ReportImg} />,
				getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
				isActive: false,
			},
			{
				name: "pole-inventory",
				label: "Pole",
				path: "/pole-inventory",
				icon: <img src={ReportImg} />,
				getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
				isActive: false,
			},
			{
				name: "ilm-inventory",
				label: "ILM",
				path: "/ilm-inventory",
				icon: <img src={ReportImg} />,
				getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
				isActive: false,
			},
			{
				name: "summary-inventory",
				label: "Summary",
				path: "/summary-inventory",
				icon: <img src={ReportImg} />,
				getIcon: (isSelected) => (isSelected ? <img src={ReportActiveImg} /> : <img src={ReportImg} />),
				isActive: false,
			},

		]
	},
	{
		name: "user",
		label: "User",
		path: "/user",
		icon: <PersonIcon />,
		getIcon: (isSelected) => (isSelected ? <PersonIcon /> : <PersonIcon />),
		isActive: false,
	},
	{
		name: "permission",
		label: "Permission",
		path: "/permission",
		icon: <LockOpenIcon />,
		getIcon: (isSelected) => (isSelected ? <LockOpenIcon /> : <LockOpenIcon />),
		isActive: false,
	},
	{
		name: "project",
		label: "Project",
		path: "/project",
		icon: <Diversity3Icon />,
		getIcon: (isSelected) => (isSelected ? <Diversity3Icon /> : <Diversity3Icon />),
		isActive: false,
	},
	{
		name: "com-list",
		label: "Com List",
		path: "/com-list",
		icon: <ListIcon />,
		getIcon: (isSelected) => (isSelected ? <ListIcon /> : <ListIcon />),
		isActive: false,
	},
	{
		name: "settings",
		label: "Settings",
		path: "/settings",
		icon: <img src={SettingsImg} />,
		getIcon: (isSelected) => (isSelected ? <img src={SettingsActiveImg} /> : <img src={SettingsImg} />),
		isActive: false,
	},
	{
		name: "config",
		label: "Config",
		path: "/config",
		icon: <img src={SettingsImg} />,
		getIcon: (isSelected) => (isSelected ? <OfflinePinIcon /> : <OfflinePinIcon />),
		isActive: false,
	},
	// {
	// 	name: "mock",
	// 	label: "Mock",
	// 	path: "/mock",
	// 	icon: <img src={SettingsImg} />,
	// 	getIcon: (isSelected) => (isSelected ? <OfflinePinIcon /> : <OfflinePinIcon />),
	// 	isActive: false,
	// },
	// {
	//   name: "mapView",
	//   label: "Map View",
	//   path: "/map-view",
	//   icon: <img src={MapViewImg} />,
	//   getIcon: (isSelected) => (isSelected ? MapViewActiveImg : MapViewImg),
	//   isActive: false,
	// },
	// {
	//   name: "users",
	//   label: "Users",
	//   path: "/users",
	//   icon: <img src={UsersImg} />,
	//   getIcon: (isSelected) => (isSelected ? UsersActiveImg : UsersImg),
	//   isActive: false,
	// },
	// {
	//   name: "vendorDetails",
	//   label: "Vendor Details",
	//   path: "/vendor-details",
	//   icon: <img src={VendorDetailsImg} />,
	//   getIcon: (isSelected) =>
	//     isSelected ? VendorDetailsActiveImg : VendorDetailsImg,
	//   isActive: false,
	// },
];

const getCollapseIcon = (isExpand) => {
	// debugger;
	return (isExpand ? <ExpandMoreIcon className="img-chevron" /> : <ChevronRightIcon className="img-chevron" />);
}

const getHeaderDetail = (propName) => {
	let configResponse = localStorage.getItem("firebaseConfigApiResponse");
	let detail = "";
	if (configResponse) {
		configResponse = JSON.parse(configResponse);
		switch (propName) {
			case "email":
			default: {
				detail = localStorage.getItem("userEmail") || "";
				break;
			}
			case "city": {
				detail = configResponse?.displayName;
			}
		}
	}
	return detail;
};


export default function Sidebar() {

	const history = useHistory();
	const [sideMenuListState, setSideMenuListState] = useState([...sideMenuList]);
	const [ticketFlag, setTicketFlag] = useState(false);


	const handleClick = async () => {
		await masterLogout();
		NotificationManager.success("User logged out Successfully", "", 3000);
		history.push("/");
	};

	const handleChangeArea = async () => {
		await logout();

		history.push("/");
	};

	const handleExpand = (event, currentItem) => {
		event.preventDefault();
		// debugger;
		let tempState = [...sideMenuListState];
		tempState = tempState.map((item) => {
			if (item.name === currentItem.name) {
				return {
					...item,
					isActive: true,
				};
			} else {
				if (item.subMenu != undefined) {
					let activeSubItem = item.subMenu.find((sItem) => sItem.isActive == true);
					if (activeSubItem == undefined) {
						return {
							...item,
							isActive: false,
						};
					}
				}

			}
			return {
				...item,
			};
		});
		setSideMenuListState(tempState);
	};

	const handleMainNavigate = (event, currentItem) => {
		event.preventDefault();
		let tempState = [...sideMenuListState];
		tempState = tempState.map((item) => {
			if (item.name === currentItem.name) {
				return {
					...item,
					isActive: true,
				};
			}
			if (item.subMenu != undefined) {
				item.subMenu = item.subMenu.map((sitem) => {
					return {
						...sitem,
						isActive: false,
					};
				});
			}
			return {
				...item,
				isActive: false,
			};
		});
		setSideMenuListState(tempState);
		history.push(currentItem.path);
	};

	const handleNavigate = (event, currentItem, subItem) => {
		event.preventDefault();
		event.stopPropagation();
		// debugger;
		let tempState = [...sideMenuListState];
		tempState = tempState.map((item) => {
			if (item.name === currentItem.name) {
				if (item.subMenu != undefined) {
					item.subMenu = item.subMenu.map((sitem) => {
						if (sitem.name === subItem.name) {
							return {
								...sitem,
								isActive: true,
							};
						} else {
							return {
								...sitem,
								isActive: false,
							};
						}
					});
				}
				return {
					...item,
					isActive: true,
				};
			}
			if (item.subMenu != undefined) {
				item.subMenu = item.subMenu.map((sitem) => {
					return {
						...sitem,
						isActive: false,
					};
				});
			}
			return {
				...item,
				isActive: false,
			};
		});
		// debugger;
		setSideMenuListState(tempState);
		history.push(subItem.path);
	};

	useEffect(() => {
		//const [ticketFlag , setTicketFlag] = useState(true);
		console.log("init side menu");
		let tempState = [...sideMenuListState];
		tempState = tempState.map((item) => {
			if (item.path === history.location.pathname) {
				return {
					...item,
					isActive: true,
				};
			}
			if (item.subMenu != undefined) {
				var isSubItemActive = false;
				item.subMenu = item.subMenu.map((sitem) => {
					if (sitem.path === history.location.pathname) {
						isSubItemActive = true;
						return {
							...sitem,
							isActive: true,
						};
					}
					return {
						...sitem,
					};
				});
				if (isSubItemActive == true) {
					return {
						...item,
						isActive: true,
					};
				}
			}
			return {
				...item,
				isActive: false,
			};
		});
		let sideMenu = [...tempState]; // Clone the original state to avoid mutations

		// Main menu filtering
		if (!checkUserAccess("schedule")) {
			sideMenu = sideMenu.filter(item => item.name !== "settings");
		}
		// if (!checkUserAccess("mock_data")) {
		// 	sideMenu = sideMenu.filter(item => item.name !== "mock");
		// }
		if (!checkUserAccess("project")) {
			sideMenu = sideMenu.filter(item => item.name !== "project");
		}
		if (!checkUserAccess("com-list")) {
			sideMenu = sideMenu.filter(item => item.name !== "com-list");
		}
		if (!checkUserAccess("ticket")) {
			sideMenu = sideMenu.filter(item => item.name !== "ticket");
		}
		if (!checkUserAccess("create_ticket") && !checkUserAccess("reopen_ticket") && !checkUserAccess("resolve_ticket")) {
			sideMenu = sideMenu.filter(item => item.name !== "ticket");
		}
		if (!checkUserAccess("permission_config")) {
			sideMenu = sideMenu.filter(item => item.name !== "permission");
		}
		if (!checkUserAccess("user_management")) {
			sideMenu = sideMenu.filter(item => item.name !== "user");
		}
		if (!checkUserAccess("inventory_slc") && !checkUserAccess("inventory_ilm") && !checkUserAccess("inventory_lamp") &&
			!checkUserAccess("inventory_summary") && !checkUserAccess("inventory_pole")) {
			sideMenu = sideMenu.filter(item => item.name !== "inventory");
		}
		if (!checkUserAccess("view_config_ilm") && !checkUserAccess("view_config_slc3") &&
			!checkUserAccess("view_config_slc1") && !checkUserAccess("view_config")) {
			sideMenu = sideMenu.filter(item => item.name !== "config");
		}

		// Submenu filtering
		sideMenu = sideMenu.map(ticket => {
			if (ticket.subMenu) {
				let updatedSubMenu = [...ticket.subMenu];

				if (ticket.name === "inventory") {
					if (!checkUserAccess("inventory_slc")) {
						updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "slc-inventory");
					}
					if (!checkUserAccess("inventory_ilm")) {
						updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "lamp-inventory");
					}
					if (!checkUserAccess("inventory_lamp")) {
						updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "ilm-inventory");
					}
					if (!checkUserAccess("inventory_summary")) {
						updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "summary-inventory");
					}
					if (!checkUserAccess("inventory_pole")) {
						updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "pole-inventory");
					}
				}

				if (ticket.name === "ticket") {
					if (!checkUserAccess("create_ticket")) {
						updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "create-tickets");
					}
					if (!checkUserAccess("reopen_ticket")) {
						updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "closed-tickets");
					}
					if (!checkUserAccess("resolve_ticket")) {
						updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "active-tickets");
					}
				}

				return {
					...ticket,
					subMenu: updatedSubMenu
				};
			}
			return ticket;
		});

		// Update state once at the end
		setSideMenuListState(sideMenu);

		// var sideMenu = tempState;

		// if (checkUserAccess("schedule")) {
		// 	setSideMenuListState(sideMenu);
		// }
		// else {
		// 	sideMenu = tempState.filter(item => item.name !== 'settings');
		// }

		// if (checkUserAccess("ticket")) {
		// 	setSideMenuListState(sideMenu);

		// }
		// else {
		// 	sideMenu = tempState.filter(item => item.name !== 'ticket')
		// 	setSideMenuListState(sideMenu);
		// }

		// if (!checkUserAccess("create_ticket") && !checkUserAccess("reopen_ticket") && !checkUserAccess("resolve_ticket")) {
		// 	sideMenu = tempState.filter(item => item.name !== 'ticket')
		// 	setSideMenuListState(sideMenu);
		// }
		// if (!checkUserAccess("permission_config")) {
		// 	sideMenu = tempState.filter(item => item.name !== 'permission')
		// 	setSideMenuListState(sideMenu);
		// }
		// if (!checkUserAccess("user_management")) {
		// 	sideMenu = tempState.filter(item => item.name !== 'user')
		// 	setSideMenuListState(sideMenu);
		// }
		// if (!checkUserAccess("inventory_slc") && !checkUserAccess("inventory_ilm") && !checkUserAccess("inventory_lamp") && !checkUserAccess("inventory_summary") && !checkUserAccess("inventory_pole")) {
		// 	sideMenu = tempState.filter(item => item.name !== 'inventory')
		// 	setSideMenuListState(sideMenu);
		// }

		// ///Manage Config in menu
		// if (checkUserAccess("view_config_ilm") === false && checkUserAccess("view_config_slc3") === false &&
		// 	checkUserAccess("view_config_slc1") === false && checkUserAccess("view_config") === false) {
		// 	debugger;
		// 	sideMenu = tempState.filter(item => item.name !== 'config')
		// 	setSideMenuListState(sideMenu);
		// }

		// setSideMenuListState(sideMenu.map(ticket => {
		// 	let updatedSubMenu = ticket.subMenu
		// 	if (ticket.name === 'inventory') {
		// 		if (!checkUserAccess("inventory_slc")) {
		// 			updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "slc-inventory");
		// 		}
		// 		if (!checkUserAccess("inventory_ilm")) {
		// 			updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "lamp-inventory");
		// 		}
		// 		if (!checkUserAccess("inventory_lamp")) {
		// 			updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "ilm-inventory");
		// 		}
		// 		if (!checkUserAccess("inventory_summary")) {
		// 			updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "summary-inventory");
		// 		}
		// 		if (!checkUserAccess("inventory_pole")) {
		// 			updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "pole-inventory");
		// 		}
		// 		return {
		// 			...ticket,
		// 			subMenu: updatedSubMenu
		// 		};
		// 	}
		// 	if (ticket.name === 'ticket') {
		// 		let updatedSubMenu = ticket.subMenu
		// 		if (!checkUserAccess("create_ticket")) {
		// 			updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "create-tickets");
		// 		}
		// 		if (!checkUserAccess("reopen_ticket")) {
		// 			updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "closed-tickets");
		// 		}
		// 		if (!checkUserAccess("resolve_ticket")) {
		// 			updatedSubMenu = updatedSubMenu.filter(subItem => subItem.name !== "active-tickets");
		// 		}
		// 		return {
		// 			...ticket,
		// 			subMenu: updatedSubMenu
		// 		};
		// 	}
		// 	return ticket;
		// }));



	}, []);

	return (
		<nav style={{ height: '100%', overflowY: 'auto',scrollbarWidth: 'none',border: '1px solid #ccc' }} className="sidebar" >
			<div className="sidebar-logo-wrapper">
				<img src={AmuraLogoImg} />
				<div>Powered by Hitech Engineering</div>
			</div>
			<div className="sidebar-wrapper">
				<span style={{ alignContent: "center" }} className="header-city">{getHeaderDetail("city")} city </span>
			</div>
			<ul className="main-menu">
				{sideMenuListState.map((item) => {
					if (item.subMenu == undefined) {
						return (
							<li
								key={item.name}
								className={
									item.isActive ? "sideMenu-active" : "sideMenu-inactive"
								}
								onClick={(e) => handleMainNavigate(e, item)}
							>
								<div>
									{/* {item.icon} */}
									{item.getIcon(item.isActive)}
									<div>{item.label}</div>
								</div>
							</li>);
					} else {
						return (
							<li
								key={item.name}
								className={
									item.isActive ? "sideMenu-active-noselect" : "sideMenu-inactive"
								}
								onClick={(e) => handleExpand(e, item)}
							>
								<div>
									{/* {item.icon} */}
									{item.getIcon(item.isActive)}
									<div>{item.label}</div>
									{/* <img className="img-chevron" src={getCollapseIcon(item.isActive)} /> */}
									{getCollapseIcon(item.isActive)}
								</div>
								{(item.isActive && item.subMenu != undefined) ? <div>
									<ul style={{ width: "100%" }}>
										{item.subMenu.map((subMenuItem) => {
											return (
												<li
													key={subMenuItem.name}
													className={
														subMenuItem.isActive ? "sideMenu-active" : "sideMenu-inactive"
													}
													onClick={(e) => handleNavigate(e, item, subMenuItem)}
												>
													<div>
														{/* {item.icon} */}
														{subMenuItem.getIcon(subMenuItem.isActive)}
														<div>{subMenuItem.label}</div>
													</div>
												</li>
											);
										})}
									</ul>
								</div> : <></>}

							</li>
						);
					}

				})}

				<li className="sideMenu-inactiv" onClick={(e) => handleChangeArea(e)}>
					<div>
						<ChangeCircleIcon />
						<div>Change Area</div>
					</div>
				</li>
				<li className="sideMenu-logout" onClick={(e) => handleClick(e)}>
					<div>
						<img src={LogoutImg} />
						<div>Log out</div>
					</div>
				</li>
			</ul>
		</nav>
	);
}
